import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { Window, WindowHeader, WindowContent, Button } from 'react95';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import mo from '../Components/image/ChatGPT Image Jul 24, 2025, 06_40_45 PM.png';

export default function ArtworkPage() {
  const { id } = useParams();
  const [artwork, setArtwork] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => {
    // Try to go back one page
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      // Fallback: Navigate to the gallery
      navigate('/Anime-Art-Hub');
    }
  };

  useEffect(() => {
    async function fetchArtwork() {
      const { data } = await supabase
        .from('artworks')
        .select('*')
        .eq('id', id)
        .single();
      setArtwork(data);
    }
    fetchArtwork();
  }, [id]);

  if (!artwork) return <div>Loading...</div>;

  return (
    <div className='container'>
      <Helmet>
        {/* Open Graph (OG) meta tags for Facebook, LinkedIn, etc. */}
        <meta property="og:title" content={artwork.description} />
        <meta property="og:description" content={artwork.description} />
        <meta property="og:image" content={artwork.image_url} />
        <meta property="og:url" content={`https://solana.animeco.in/Anime-Art-Hub/artwork/${id}`} />
        <meta property="og:type" content="website" />

        {/* Twitter Card meta tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={artwork.description} />
        <meta name="twitter:description" content={artwork.description} />
        <meta name="twitter:image" content={artwork.image_url} />
        <meta name="twitter:url" content={`https://solana.animeco.in/Anime-Art-Hub/artwork/${id}`} />
      </Helmet>
      <h1 className='centerani'>$ANI Artist Portal</h1>
      <Window className='artwork-window'>
        <WindowHeader className='artwork-header'>
          "{artwork.description}" by {artwork.title}
          <Button onClick={handleBack}>X</Button>
        </WindowHeader>
        <WindowContent>
          <img
            src={artwork.image_url}
            alt={artwork.decription}
            className='full-image'
          />
          <br />
          <Button onClick={handleBack}>Back to Gallery</Button>
        </WindowContent>
      </Window>
      <div className='video-background mobile-bg'>
        <img src={mo} alt='Mobile Background' className='image-content' />
        <div className='overlay'></div>
      </div>
    </div>
  );
}